var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframe-wrap",staticStyle:{"max-width":"96rem"}},[_c('iframe',{attrs:{"src":_vm.iframeSrc,"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }